import { render, staticRenderFns } from "./evenementsItem.vue?vue&type=template&id=7bde4c3c&"
import script from "./evenementsItem.vue?vue&type=script&lang=js&"
export * from "./evenementsItem.vue?vue&type=script&lang=js&"
import style0 from "./evenementsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports